<template>
  <div class="AnswerList">
    <div class="answer_search">
      <div class="dealers_answer">
        经销商知识文章
      </div>
      <el-row :gutter="10">
        <el-col :span="18">
          <el-input
            placeholder="请输入内容"
            v-model="input"
            clearable>
        </el-input>
        </el-col>
        <el-col :span="2">
          <el-button type="primary" @click="searchWithKey">搜索</el-button>
        </el-col>
      </el-row>
    </div>
    <div class="answer_list" :style="'width:'+myProductDivWidth+'px;'" v-loading="searchLoading">
      <div class="answer_tip">
        第 {{(total>1)?(page-1)*10+1:0}} - {{(page*10&lt;total)?page*10:total}} 个结果，共 {{total}} 个
      </div>
      <div v-for="item in items" :key="item.id" class="answer_title" @click="chooseAnswer(item.id)">
        {{item.title}}
      </div>
    </div>
    <div class="block">
      <el-pagination
          layout="prev, pager, next"
          :pager-count = 5
          @current-change = pageChangedHandler
          :total="total">
      </el-pagination>
    </div>
  </div>
</template>

<script>
    export default {
        name: "AnswerList",
        data() {
            return {
                myProductDivWidth: document.documentElement.clientWidth - 58,
                input:'',
                search:'',
                page: 1,
                searchLoading: false,
                total: 0,    // 总条数
                totalPages: 0,   // 总页数
                items:[]   // 当前页数据
            }
        },
        created() {
            this.open();
        },
        methods: {
            open() {
                this.$prompt('请输入经销商编码', '提示', {
                    confirmButtonText: '确定',
                    showClose: false,
                    showCancelButton: false,
                    closeOnClickModal: false,
                    closeOnPressEscape: false,
                    closeOnHashChange: false,
                    inputPattern: /^\d{1,}$/,
                    customClass: 'message-logout'
                }).then(({ value }) => {
                    console.log("搜索经销商编码：",value);
                    this.$axios.get(this.$baseURL + `/incident/dealer/`+value)
                        .then((response)=> {
                            console.log(response);
                            if(response.data == 0){
                                this.$message({
                                    type: 'warning',
                                    message: '未找到经销商',
                                    offset: 60
                                });
                                this.open();
                            }else{
                                this.queryByPage();
                            }
                        })
                        .catch(error=> {
                            console.log(error);
                            this.$message({
                                type: 'warning',
                                message: '提交失败，请重试或联系客服',
                                offset: 60
                            });
                            this.open();
                        });
                })
            },
            searchWithKey(){
                if(this.search == this.input){
                    return
                }
                this.search = this.input;
                this.page = 1;
                this.queryByPage();
            },
            pageChangedHandler(page){
                this.page = page;
                this.queryByPage();
            },
            queryByPage(){
                this.searchLoading = true;
                this.$axios.get(this.$baseURL + `/answer/dealers`,{
                    params:{
                        page : this.page,
                        search: this.search
                    }
                })
                    .then((response)=> {
                        console.log(response.data);
                        this.total = response.data.total;
                        this.totalPages = response.data.totalPages;
                        this.items = response.data.items;
                        this.searchLoading = false;
                    })
                    .catch(error=> {
                        console.log(error);
                        this.$message({
                            type: 'warning',
                            message: '获取知识文章失败，请重试',
                            offset: 30
                        });
                        this.searchLoading = false;
                    });
            },
            chooseAnswer(id){
                this.$router.push({
                    name:"AnswerDetail",
                    params: {
                        answerId: id
                    }
                })
            }
        }
    };
</script>

<style scoped>

  .AnswerList {
    background: #FFF;
    border: 1px solid #DCDFE6;
    box-shadow: 0 2px 4px 0 rgba(0,0,0,.12), 0 0 6px 0 rgba(0,0,0,.04);
  }
  .dealers_answer {
    padding: 30px;
    font-size: 30px;
    color: #3e5c9a;
    font-family: "Helvetica Neue",Helvetica,"PingFang SC","Hiragino Sans GB","Microsoft YaHei","微软雅黑",Arial,sans-serif;
    /*background: url("~@/assets/bg15-1.png") center center no-repeat;*/
    /*background-size: cover;*/
  }
  .answer_search {
    padding: 30px 20px;
  }
  .answer_list{
    padding: 10px 20px 10px 20px;
    overflow: hidden;
  }
  .answer_tip {
    text-align: right;
    font-size: 12px;
    margin-bottom: 5px;
  }
  .answer_title {
    padding: 10px 0px 10px 5px;
    width: 100%;
    text-align: left;
    font-size: 15px;
    font-family: 'Avenir', Helvetica, Arial, sans-serif;
    color: #1c7ee2;
    border-top: 1px solid #c5c5c5;
    word-break:keep-all;/*不换行*/
    white-space:nowrap;
    overflow: hidden;
    text-overflow:ellipsis;/*当对象内文本溢出时显示省略标记(...)；需与overflow:hidden;一起使用。*/
  }
  .block {
    margin: 10px 0px;
  }

  .msg-div {
    position: relative;
    top: 2px;
    height: 17px;
  }
</style>
